export default __webpack_public_path__ + "static/media/my_unsplash_logo.c888ca72.svg";